import { normalizeError } from '../api/core/errors';
import { izteachSession } from '../api/session';
import { featureEnabled } from '../config/features';
import { userErrorMessage } from '../stores/userError';

import { bankAccess } from './access';
import type { BankAccess } from './access';
import { forbiddenMessage, sessionMessages } from './messages';
import type { SessionRemedy } from './messages';

// Session and failure wording shared by the store and the rich-question actions.

// with SSO there is no /setup to send the teacher to
export function sessionRemedy(): SessionRemedy {
  return featureEnabled('sso') ? 'sso' : 'setup';
}

export function reason(error: unknown): string {
  // a 403 here is the gateway refusing the role, which the shared mapper has no way to say
  return forbiddenMessage(error, sessionRemedy()) || userErrorMessage(error);
}

export function failure(error: unknown): { error: string; offline: boolean } {
  return { error: reason(error), offline: normalizeError(error).kind === 'network' };
}

export function currentAccess(): BankAccess {
  return bankAccess(izteachSession.accessToken, izteachSession.userId);
}

export function setupError(access: BankAccess): string {
  const messages = sessionMessages(sessionRemedy());
  return access.status === 'not-teacher' ? messages.notTeacher : messages.signedOut;
}
